import { memo, useCallback, useMemo } from "react";
import Navigator from "./components/Navigator";
import { Routes } from "const";
import { ArchiveIcon, BriefcaseIcon, InformationIcon, ResearchIcon } from "components/CustomIcon";
import { useDispatch } from "react-redux";
import { redirectToPrimaryProduct, redirectToSecondaryProduct } from "redux/reducers/disclaimer";

function RetailNavigator({ navigate, shouldReplaceThisPath }) {
  const dispatch = useDispatch();

  const menus = useMemo(
    () => [
      {
        key: "primary",
        label: "ตลาดแรก",
        icon: <ArchiveIcon />,
        menuActiveRegex: [/^\/primary\/primary-product\/?/i],
      },
      {
        key: "secondary",
        label: "ตลาดรอง",
        icon: <BriefcaseIcon />,
        menuActiveRegex: [/^\/secondary\/?/i],
      },
      {
        key: "structure-note",
        label: "หุ้นกู้อนุพันธ์",
        icon: <i style={{ fontSize: 17 }} className="feather-icon icon-trending-up"></i>,
        menuActiveRegex: [/^\/structure-note/i, /^\/primary\/complex-product\/?/i],
      },
      {
        key: "research",
        label: "บทวิเคราะห์",
        icon: <ResearchIcon />,
        menuActiveRegex: [/^\/research/i],
      },
      {
        key: "profile",
        label: "ข้อมูลส่วนตัว",
        icon: <InformationIcon />,
        menuActiveRegex: [
          /^\/profile/i,
          new RegExp(`^${Routes.Register.CustomerInfo}`, "i"),
          new RegExp(`^${Routes.Register.RiskResult}`, "i"),
          new RegExp(`^${Routes.Register.Suitability}`, "i"),
          new RegExp(`^${Routes.Register.TermsConditions}`, "i"),
        ],
      },
    ],
    []
  );

  const onMenuClick = useCallback(
    (key) => {
      switch (key) {
        case "primary":
          dispatch(redirectToPrimaryProduct({ replaceUrl: shouldReplaceThisPath() }));
          break;
        case "secondary":
          dispatch(redirectToSecondaryProduct({ replaceUrl: shouldReplaceThisPath() }));
          break;
        case "structure-note":
          navigate(Routes.StructureNote);
          break;
        case "research":
          navigate(Routes.Research.ResearchList);
          break;
        case "profile":
          navigate(Routes.Profile);
          break;
        default:
          break;
      }
    },
    [dispatch, navigate, shouldReplaceThisPath]
  );

  return <Navigator menus={menus} onMenuClick={onMenuClick} />;
}
export default memo(RetailNavigator);
